import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';
import {
  getConfiguredEmails,
  IConfiguredEmailContext,
  ConfiguredEmailContextType,
} from 'wisestep-api';
export const EmailConfigurationContext = createContext<IConfiguredEmailContext | null>(null);

export default function EmailConfigurationContextProvider(
  props: PropsWithChildren<IConfiguredEmailContext | null>
) {
  const [configuredEmail, setConfiguredEmail] = useState<IConfiguredEmailContext | null>(null);
  const [updateContext, setUpdateContext] = useState<boolean>(false);
  useEffect(() => {
    (async function () {
      if (!configuredEmail || updateContext) {
        const userReq = await getConfiguredEmails();
        const emailSettings: ConfiguredEmailContextType[] = userReq.data;
        const response = {
          configuredData: emailSettings,
        };
        setConfiguredEmail(response);
        setUpdateContext(false);
      }
    })();
  }, [updateContext, configuredEmail]);
  return (
    <EmailConfigurationContext.Provider
      value={{ ...configuredEmail, setConfiguredEmail, setUpdateContext }}
    >
      {props.children}
    </EmailConfigurationContext.Provider>
  );
}
export function useEmailConfigurationContext() {
  const context = useContext(EmailConfigurationContext);
  if (!context) {
    throw new Error('useAppState must be used within the EmailConfigurationContextProvider');
  }
  return context;
}
